import VideoControls from '@utils/videoControls';

export default class ValuePropsModule {
  constructor(context) {
    if (context.querySelector('.js--video-controls'))
      new VideoControls(context.querySelector('.js--video-controls'), context);
  }
}
